import type { InboxProviderId } from '@/services/inboxSync';

type InboxStatusResult = { connected?: boolean } | null | undefined;

type PollOptions = {
  maxAttempts?: number;
  baseDelayMs?: number;
  stepDelayMs?: number;
  maxDelayMs?: number;
};

const DEFAULT_OPTIONS: Required<PollOptions> = {
  maxAttempts: 6,
  baseDelayMs: 800,
  stepDelayMs: 400,
  maxDelayMs: 2400,
};

export async function pollInboxStatusUntilConnected(
  provider: InboxProviderId,
  checkStatus: (provider: InboxProviderId) => Promise<InboxStatusResult>,
  options?: PollOptions,
): Promise<boolean> {
  const config = { ...DEFAULT_OPTIONS, ...(options || {}) };

  for (let attempt = 0; attempt < config.maxAttempts; attempt++) {
    try {
      const status = await checkStatus(provider);
      if (Boolean(status?.connected)) {
        return true;
      }
    } catch {
      // Ignore transient fetch/read failures and retry.
    }

    if (attempt < config.maxAttempts - 1) {
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          Math.min(config.baseDelayMs + attempt * config.stepDelayMs, config.maxDelayMs),
        ),
      );
    }
  }

  return false;
}
